import { useState } from "react";

import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
// import SpotlightCarousel from "../components/SpotlightCarousel";

import MostOrderedProducts from "../components/MostOrderedProducts";
// import ProductCarousel from "../components/ProductCarousel";
import OurClients from "../components/ourClient";

import HowItWorks from "../components/HowItWorks";
import Customizations from "../components/Customizations";
import Testimonials from "../components/Testimonials";
import WhyChooseUs from "../components/WhyChooseUs";
import FAQ from "../components/FAQ";
import LeadCapture from "../components/LeadCapture";
import MiniPortfolio from "../components/MiniPortfolio";
import ProductOrbit from "../components/ProductOrbit";

import Footer from "../components/Footer";


export default function Home() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div
      className="
        bg-[#f4f1ec]
        text-[#1a1a1a]
        overflow-x-hidden
      "
    >
      {/* NAVBAR*/}
      <Navbar /> 

      {/* HERO SECTION */}
      <Hero />

      {/* TRUST STRIP → Opens SpotlightCarousel */}
      {/* <TrustStrip onOpen={(index) => setOpenIndex(index)} /> */}

      {/* SPOTLIGHT MODAL */}
      {/* {openIndex !== null && (
        <SpotlightCarousel
          startIndex={openIndex}
          onClose={() => setOpenIndex(null)}
        />
      )} */}

      {/* MOST ORDERED */}
      <MostOrderedProducts />

       {/* our clients */}
      <OurClients />

      {/* WHY CHOOSE US */}
      {/* <WhyChooseUs /> */}

      

      

      {/* PRODUCT CAROUSEL */}
      {/* <ProductCarousel /> */}

      {/* HOW IT WORKS */}
      <HowItWorks />
      
      <MiniPortfolio />
      {/* TESTIMONIALS */}
      <Testimonials />
      <ProductOrbit />

      {/* CUSTOMIZATIONS */}
      {/* <Customizations /> */}
      {/* FAQ */}
      <FAQ />

      

      

      {/* LEAD CAPTURE */}
      {/* <LeadCapture /> */}

      {/* FOOTER */}
      <Footer />
    </div>
  );
}
